import '../App.css';
import '../styles/Modules.css';

export const LoadingHistory = () => {
const loadingLines = Array.from({ length: 7 }, (_, index) => (
        <div className='loading-line' key={index}></div>
    ));

    return (
        <div className='module-container dim-dashboard view-history-module loading-state test-bg' style={{overflow: 'hidden'}}>
                    <div className='App-text dashboard-header header-icon-row'>
                    <div className='loading-line header-line'></div>
                    <div style={{display:'flex', flexDirection: 'row', flexBasis: '20%', justifyContent: 'flex-end', gridGap: '10px'}}>
                        <div className='loading-line loading-icon'></div>
                    </div>
                </div>

                <div className='table-header-row'>
                    <span className='startTime loading-line columnName'></span>
                    <span className='interval loading-line columnName'></span>
                    <span className='export-name loading-line columnName'></span>
                </div>

                 <div className='loading-container'>
                    {loadingLines}
                </div>
               
            </div>
    )
}
